const normalizePlayerId = playerId =>
  playerId === undefined || playerId === null || playerId === ""
    ? null
    : String(playerId)

const getLegacyEntryPlayerId = entry =>
  normalizePlayerId(entry?.user?.userId ?? entry?.userId)

const getLegacyEntryPartnerId = entry =>
  normalizePlayerId(entry?.partner?.userId ?? entry?.partnerId)

const getLegacyEntries = competition => [
  ...(competition?.mainList || []),
  ...(competition?.waitingList || []),
  ...(competition?.preRegistrationList || []),
]

const getLegacyCount = (eventDetails, counts) =>
  (eventDetails?.competitions || []).reduce(
    (count, competition) => count + getLegacyEntries(competition).filter(counts).length,
    0
  )

// The entries of an account playing as itself in this event. PRD 16 LR11c: a Tenis10 child's entry rides
// on its parent's account and is the child's, so it never counts here.
export const getPlayerEntryCount = (eventDetails = {}, playerId) => {
  const normalizedPlayerId = normalizePlayerId(playerId)

  if (!normalizedPlayerId) {
    return 0
  }

  const compactCount =
    eventDetails?.entryCountsByPlayerId?.[normalizedPlayerId]

  if (Number.isFinite(compactCount)) {
    return compactCount
  }

  return getLegacyCount(
    eventDetails,
    entry =>
      !entry?.profileId &&
      (normalizedPlayerId === getLegacyEntryPlayerId(entry) ||
        normalizedPlayerId === getLegacyEntryPartnerId(entry))
  )
}

// The entries of a slot's or a person's participant: a Tenis10 child (profileId) counts its own — never its
// parent's nor a sibling's (PRD 16 LR11c); an adult its account's.
export const getParticipantEntryCount = (eventDetails = {}, person) => {
  const profileId = normalizePlayerId(person?.profileId)

  if (!profileId) {
    return getPlayerEntryCount(eventDetails, person?.userId)
  }

  const childCount = eventDetails?.entryCountsByProfileId?.[profileId]
  return Number.isFinite(childCount)
    ? childCount
    : getLegacyCount(eventDetails, entry => normalizePlayerId(entry?.profileId) === profileId)
}
